import client from './client';

export const listUsers = async (params = {}) => {
  const { data } = await client.get('/users', { params });
  return data;
};

export const getUser = async (id) => {
  const { data } = await client.get(`/users/${id}`);
  return data;
};

export const createUser = async (payload) => {
  const { data } = await client.post('/users', payload);
  return data;
};

export const updateUser = async (id, payload) => {
  const { data } = await client.put(`/users/${id}`, payload);
  return data;
};

export const deleteUser = async (id) => {
  const { data } = await client.delete(`/users/${id}`);
  return data;
};

export const getCalendarToken = async (id) => {
  const { data } = await client.get(`/users/${id}/calendar-token`);
  return data;
};

export const assignEducators = async (studentId, payload) => {
  const { data } = await client.patch(`/users/${studentId}/educators`, payload);
  return data;
};

export default {
  listUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
  getCalendarToken,
  assignEducators,
};
